module.exports = __webpack_public_path__ + "static/media/msr-loading.712fbe96.gif";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/msr-loading.gif
// module id = 1145
// module chunks = 0